"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgStethoscopeFilled = function (props) { return (react_1.default.createElement("svg", __assign({ width: '1em', height: '1em', viewBox: '0 0 24 24' }, props),
    react_1.default.createElement("path", { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M4 2c-1.333 0-2 .667-2 2v7c0 2.96 2.19 5.5 5.14 5.91.62 3.01 3.28 5.09 6.36 5.09a6.499 6.499 0 006.5-6.5v-3.69c1.16-.42 2-1.52 2-2.81a3 3 0 00-6 0c0 1.29.84 2.4 2 2.81v3.6c0 2.5-2 4.5-4.5 4.5-2 0-3.68-1.21-4.28-3.01C12 16.3 14 13.8 14 11V4c0-1.333-.667-2-2-2h-1c-.667 0-1 .333-1 1s.333 1 1 1h1v7a4 4 0 11-8 0V4h1c.667 0 1-.333 1-1s-.333-1-1-1H4z' }))); };
exports.default = SvgStethoscopeFilled;
//# sourceMappingURL=StethoscopeFilled.js.map